import { useNewsItems } from "./newsQueries";
import { Newspaper } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { useLocale } from "@/i18n/locale";

/**
 * Horizontal ticker of menopause news. Auto-scrolls; pauses on hover.
 * Respects prefers-reduced-motion (falls back to a static list).
 */
export function NewsTicker() {
  const locale = useLocale();
  const { items, loading } = useNewsItems(15, locale);
  const label = locale === "es" ? "Meno Noticias" : "Meno News";
  const seeAll = locale === "es" ? "Ver todas →" : "See all →";
  const shopTag = locale === "es" ? "Comprar" : "Shop";
  const newsHref = locale === "es" ? "/es/noticias" : "/news";

  if (loading || items.length === 0) return null;

  const doubled = [...items, ...items];

  return (
    <div className="group relative w-full overflow-hidden border-y border-border bg-muted/40">
      <div className="flex items-center">
        <div className="flex shrink-0 items-center gap-2 border-r border-border bg-background/80 px-3 py-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          <Newspaper className="h-3.5 w-3.5" />
          <span>{label}</span>
        </div>

        <div className="relative flex-1 overflow-hidden">
          <div className="flex animate-news-marquee gap-8 whitespace-nowrap py-2 pl-6 motion-reduce:animate-none group-hover:[animation-play-state:paused]">
            {doubled.map((it, idx) => {
              const isAffiliate = !!it.affiliate_url;
              const href = it.affiliate_url || it.source_url;
              return (
                <a
                  key={`${it.id}-${idx}`}
                  href={href}
                  target="_blank"
                  rel={
                    isAffiliate
                      ? "nofollow sponsored noopener noreferrer"
                      : "noopener noreferrer"
                  }
                  className="text-sm hover:text-primary"
                >
                  <span className="font-medium">{it.title}</span>
                  <span className="ml-2 text-xs text-muted-foreground">
                    · {it.source_name}
                  </span>
                  {isAffiliate && (
                    <span className="ml-2 rounded bg-blush/40 px-1.5 py-0.5 text-[10px] font-semibold uppercase text-plum">
                      {shopTag}
                    </span>
                  )}
                </a>
              );
            })}
          </div>
        </div>

        <Link
          to={newsHref}
          className="hidden shrink-0 border-l border-border bg-background/80 px-3 py-2 text-xs font-medium text-primary hover:underline sm:block"
        >
          {seeAll}
        </Link>
      </div>
    </div>
  );
}
